import { inject, Injectable } from '@angular/core';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  private readonly loggingService = inject(LoggingService);

  constructor() {
    this.loggingService.log('HttpService constructor');
  }
}
